import { IArtboardZIndexChain, IElement } from '@routes/private/Editor/types';
import { cloneDeep } from 'lodash';
const updateArtboardZIndexChain = (oldArtboardsZIndexChain: IArtboardZIndexChain[], artboardZIndexChain: string[], index: number) => {
    let zIndexChain: string[] = [];
    if (index > oldArtboardsZIndexChain.length-1) {
        zIndexChain = cloneDeep(artboardZIndexChain);
    }
    else {
        for(let i=0;i<oldArtboardsZIndexChain[index].zIndexChain.length;i++) {
            //TODO: Add zIndexChain elements in the same order as in oldArtboardsZIndexChain[index].zIndexChain
            if (artboardZIndexChain.includes(oldArtboardsZIndexChain[index].zIndexChain[i])) {
                zIndexChain.push(oldArtboardsZIndexChain[index].zIndexChain[i]);
            }
        }
        //Add elements that are not in oldArtboardsZIndexChain[index].zIndexChain = New elements 
        for(let i=0;i<artboardZIndexChain.length;i++) {
            if (!oldArtboardsZIndexChain[index].zIndexChain.includes(artboardZIndexChain[i])) {
                zIndexChain.push(artboardZIndexChain[i]);
            }
        }
    }
    let newArtboardZIndexChain: IArtboardZIndexChain = {artboardIndex: index, zIndexChain: zIndexChain};
    return newArtboardZIndexChain; 
}

const updateArtboardZIndexChainWithMapping = (oldArtboardsZIndexChain: IArtboardZIndexChain[], artboardZIndexChain: string[],idsMapping:any[], index: number) => {
    let zIndexChain: string[] = [];
    if (index > oldArtboardsZIndexChain.length-1) {
        zIndexChain = cloneDeep(artboardZIndexChain);
    }
    else {
        //Initialize zIndexChain
        for(let i=0;i<oldArtboardsZIndexChain[index].zIndexChain.length;i++) {
            zIndexChain.push("");
        }
        //Put zIndexChain elements in the same order as in oldArtboardsZIndexChain[index].zIndexChain
        for(let i=0;i<oldArtboardsZIndexChain[index].zIndexChain.length;i++) {
            let mappingIndex = idsMapping.findIndex(mapping => mapping.originalId === oldArtboardsZIndexChain[index].zIndexChain[i]);
            
            if (mappingIndex >= 0) {
                if(artboardZIndexChain.includes(idsMapping[mappingIndex].id)) {
                    zIndexChain[i] = cloneDeep(idsMapping[mappingIndex].id);    
                }
            }
        }
        //Add elements that are not in oldArtboardsZIndexChain[index].zIndexChain = New elements 
        for(let i=0;i<artboardZIndexChain.length;i++) {
            let mappingIndex = idsMapping.findIndex(mapping => mapping.id === artboardZIndexChain[i]);
            if (mappingIndex === -1) {
                zIndexChain.push(artboardZIndexChain[i]);
            }
        }
    }
    let newArtboardZIndexChain: IArtboardZIndexChain = {artboardIndex: 0, zIndexChain: zIndexChain.filter(zIndex => zIndex !== "")};
    return newArtboardZIndexChain; 
}

export const updateArtboardsZIndexChain = (object: IElement, oldArtboardsZIndexChain: IArtboardZIndexChain[],idsMapping:any[],oldArtboardIndex: number|undefined): IArtboardZIndexChain[] => {
    let updatedArtboardsZIndexChain: IArtboardZIndexChain[] = [];
    let useIdsMapping: boolean = idsMapping && idsMapping.length>0;
    if (object.type === "Artboards") { 
        let lastChildIndex = object.children ? object.children.length-1 :-1;
        object.children?.map((child: IElement, index: number) => {
            //const UpdateWithMapping: boolean = (oldArtboardIndex && index != oldArtboardIndex && index == lastChildIndex); 
            const UpdateWithMapping = !!((oldArtboardIndex != undefined && index != oldArtboardIndex && index == lastChildIndex));
            const artboardZIndexChain = getArtboardZIndexChain(child);
            //const updatedArboadZIndexChain = updateArtboardZIndexChain(oldArtboardsZIndexChain, artboardZIndexChain, index);
            let updatedArtboardZIndexChain = undefined;
            if(useIdsMapping && UpdateWithMapping) {
                updatedArtboardZIndexChain = updateArtboardZIndexChainWithMapping(oldArtboardsZIndexChain, artboardZIndexChain, idsMapping, (oldArtboardIndex??0));
            }
            else {
                updatedArtboardZIndexChain = updateArtboardZIndexChain(oldArtboardsZIndexChain, artboardZIndexChain, index);
            }
            updatedArtboardsZIndexChain.push(updatedArtboardZIndexChain);
        })
    } 
    else {
        const artboardZIndexChain = getArtboardZIndexChain(object);
        let artboardIndex = oldArtboardIndex ? oldArtboardIndex : 0;
        const updatedArboadZIndexChain = updateArtboardZIndexChain(oldArtboardsZIndexChain, artboardZIndexChain, artboardIndex);
        updatedArtboardsZIndexChain.push(updatedArboadZIndexChain);
    }
    return updatedArtboardsZIndexChain;
}

export const getArtboardZIndexChain = (data: IElement): string[] => {
    let ArtboardsZIndexChain: string[] = [];
    if (data.children && data.children.length>0) {
        data.children.forEach(element => {
            const types = ["Text", "Image", "Shape"];
            if (types.includes(element.type)) ArtboardsZIndexChain.push(element.id);
            ArtboardsZIndexChain = [...ArtboardsZIndexChain, ...getArtboardZIndexChain(element)];
        });
    }
    return ArtboardsZIndexChain;
}

export const defineZIndex = (ref: any, elementId: string, zIndexChain: string[] | undefined) => {
    if (zIndexChain) {
        const node = ref.current;
        if (node && node !== null) {
            const elementIndex = zIndexChain.findIndex(id => (id === elementId));
            if (elementIndex >= 0 && elementIndex !== node.getZIndex()) {
                node.setZIndex(elementIndex + 1);
            }
        }
    }
}


